const HeaderComponent = ({ title, button, iconButton, onClick, button2, iconButton2, onClick2, button3, iconButton3, onClick3 }: { title: string, button?: string, iconButton?: string, onClick?: any, button2?: string, iconButton2?: string, onClick2?: any, button3?: string, iconButton3?: string, onClick3?: any }) => {

    return (

        <header className="bg-primary">
            <div className="container-xl px-5">
                <div className="d-flex justify-content-between align-items-center">
                    <h1 className="text-white py-3 mb-0 display-6">{title}</h1>
                    {
                        button &&

                        <div className="ms-4">
                            <button className="btn btn-text-white sm me-2 mdc-ripple-upgraded" type="button" onClick={onClick}>
                                {
                                    iconButton &&

                                    <i className="material-icons leading-icon">{iconButton}</i>
                                }
                                {button}
                            </button>
                            {
                                button2 &&

                                <button className="btn btn-text-white sm me-2 mdc-ripple-upgraded" type="button" onClick={onClick2}>
                                    {
                                        iconButton2 &&

                                        <i className="material-icons leading-icon">{iconButton2}</i>
                                    }
                                    {button2}
                                </button>
                            }
                            {
                                button3 &&

                                <button className="btn btn-text-white sm me-2 mdc-ripple-upgraded" type="button" onClick={onClick3}>
                                    {
                                        iconButton3 &&

                                        <i className="material-icons leading-icon">{iconButton3}</i>
                                    }
                                    {button3}
                                </button>
                            }
                        </div>
                    }
                </div>
            </div>
        </header>
    );
}

export default HeaderComponent;